// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconPrinter = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M53 22H46.1855C46.8174 16.9218 47.4642 12.9984 47.9509 10.4667C48.2261 9.03571 47.3042 8 46.1379 8L21.8008 8.00018C20.9878 8.00018 20.3254 8.63489 20.1018 9.75769C19.6089 12.2316 18.8862 16.3889 18.1814 22H11C9.04346 22 8 23.0433 8 25V47C8 48.9566 9.04346 50 11 50H18V53C18 54.9566 19.0435 56 21 56H43C44.9565 56 46 54.9566 46 53V50H53C54.9565 50 56 48.9566 56 47V25C56 23.0433 54.9565 22 53 22ZM46 44H18V40H46V44Z" />
    </svg>
  );
};
